// extracted by mini-css-extract-plugin
export default {"success_popup":"SuccessPopup_success_popup__I7iZQ","slideIn":"SuccessPopup_slideIn__PpqLX","hide":"SuccessPopup_hide__BYgbb","slideOut":"SuccessPopup_slideOut__yDaBc"};